export const getHeaders = () => {
  const loggedData = JSON.parse(localStorage.getItem("loggedinUserdetails"));
  const accessToken = localStorage.getItem("NCD_token") || localStorage.getItem("NIKSHAY_token") || localStorage.getItem("Backend_token") || localStorage.getItem("PMNDP_token");

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
    txnUser: loggedData?.username,
    facilitytype: loggedData?.facilityType,
    facilityTypeId: loggedData?.facilityTypeId,
    stateCode: loggedData?.stateCode,
    isCdssFacility: "false",
  };
};

export const getSickleHeaders = () => {
  const accessToken = localStorage.getItem("sickle_token");

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    accessToken: `${accessToken}`
  };
};

export const getNikshayHeaders = () => {
  const loggedData = JSON.parse(localStorage.getItem("loggedinUserdetails"));
  const accessToken = localStorage.getItem("NIKSHAY_token") || localStorage.getItem("Backend_token");
  const username = JSON.parse(localStorage.getItem("NIKSHAY_loggedinUserdetails"))?.username;

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken}`,
    txnUser: loggedData?.username,
    facilityTypeId: loggedData?.facilityTypeId,
    stateCode: loggedData?.stateCode,
    username: username || ''
  };
};